import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import AdminCenterImg from '../../assets/images/Admin_Center_SM.png';
import { useIsMD } from '../../utils/useResponsive';

export default function Loading() {
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        startLoading();
    }, []);

    function loaded() {
        document.body.style.overflow = 'auto';
        setLoading(true);
    }

    function startLoading() {
        document.body.style.overflow = 'hidden';
        setLoading(false);
    }

    const isMD = useIsMD();

    return (
        <>
            {!loading && (
                <div
                    style={{
                        backgroundImage: isMD ? `url('${AdminCenterImg}')` : '',
                        backgroundSize: '100vw',
                    }}
                    className={
                        'fixed inset-0 z-50 flex h-screen w-screen flex-col items-center justify-center overflow-hidden bg-white bg-cover bg-center'
                    }>
                    <div className={'flex flex-col items-center'}>
                        <div className={'flex overflow-hidden'}>
                            <motion.h1
                                animate={{
                                    y: ['100%', '0%'],
                                }}
                                transition={{
                                    duration: 1,
                                }}
                                className={
                                    'font-montserrat text-2xl font-medium uppercase tracking-[.06em] text-SM-dark sm:text-5xl'
                                }>
                                Sprawne&nbsp;
                            </motion.h1>

                            <motion.h1
                                animate={{
                                    y: ['100%', '0%'],
                                }}
                                transition={{
                                    delay: 0.5,
                                    duration: 1,
                                }}
                                className={
                                    'font-montserrat text-2xl font-medium uppercase tracking-[.06em] text-SM-dark sm:text-5xl'
                                }>
                                Miasto
                            </motion.h1>
                        </div>

                        <motion.div
                            className={'h-1 w-1 rounded-xl bg-SM-yellow sm:mt-1'}
                            animate={{
                                width: ['0%', '50%'],
                            }}
                            transition={{
                                duration: 2,
                            }}
                        />

                        <div className={'mt-1 flex overflow-hidden'}>
                            <motion.h1
                                animate={{
                                    y: ['-100%', '0%'],
                                }}
                                onAnimationComplete={loaded}
                                transition={{
                                    delay: 1,
                                    duration: 2,
                                }}
                                className={
                                    'font-montserrat text-lg font-medium tracking-[.06em] text-SM-dark sm:text-2xl'
                                }>
                                Admin Center
                            </motion.h1>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
